"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _helpers = require("../helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* eslint-disable no-restricted-globals */

const MultiEnum = ({
  value,
  format,
  fetched,
  fetching,
  schema
}) => {
  if (!fetched) return /*#__PURE__*/_react.default.createElement("span", {
    className: "component-string-placeholder" + (fetching ? " fetching" : ""),
    style: {
      width: `${(0, _helpers.getRandomInt)(8, 10)}em`
    }
  });
  if (typeof value !== "number") return /*#__PURE__*/_react.default.createElement("span", {
    className: "component-string-placeholder" + (fetching ? " fetching" : ""),
    style: {
      width: `${(0, _helpers.getRandomInt)(8, 10)}em`
    }
  });
  return /*#__PURE__*/_react.default.createElement("div", null, Object.entries(schema.options).map(([num, string]) => {
    num = parseInt(num);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "custom-control custom-checkbox",
      key: string
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "checkbox",
      className: "custom-control-input"
      // eslint-disable-next-line no-restricted-globals
      ,
      id: name + string,
      name: name,
      checked: value === num || value & num,
      disabled: true
    }), /*#__PURE__*/_react.default.createElement("label", {
      className: "custom-control-label",
      htmlFor: name + string
    }, string));
  }));
};
var _default = exports.default = MultiEnum;
module.exports = exports.default;